'use strict';

module.exports = function (url) {
  if (typeof url !== 'string') {
    throw new TypeError("Expected a `string`, got `".concat(typeof url, "`"));
  }

  return /^[a-z][a-z\d+.-]*:/.test(url);
};